<template>
    <VideoCallButton :icon="icon" @click="toggleShare" :disabled="state.disableVideoControls" />
</template>

<script setup>
import VideoCallButton from "@/components/Common/VideoCallButton.vue";
import { EventManager, Actions, Events } from "@events";
import { onMounted, watch, ref } from 'vue';
import { useVideoCallState } from "@/stores/videoCallState";

const icon = ref("mdi-cast");
const share = ref(false);
let eventEmitter = null;
let actionEmitter = null;

const media = ref(null);

const displayMediaOptions = {
    video: {
        displaySurface: "window",
    },
    audio: true,
};

const props = defineProps({
    rtcId: {
        type: String,
        required: true,
    }
});
const state = useVideoCallState(props.rtcId);

watch(share, (value) => {
    if (value) {
        icon.value = "mdi-cast-off";
    }
    else {
        icon.value = "mdi-cast";
    }
});

onMounted(() => {
    eventEmitter = EventManager.getEventEmitter(props.rtcId);
    actionEmitter = EventManager.getActionEmitter(props.rtcId);

    actionEmitter.on(Actions.StartScreenShare, async () => {
        media.value = await getDisplayMedia();

        if (!media.value) {
            return;
        }

        media.value.getVideoTracks()[0].onended = () => {
            actionEmitter.emit(Actions.StopScreenShare);
        };

        actionEmitter.emit(Actions.SetMediaStream, {
            media: media.value,
        })
        share.value = true;
        eventEmitter.emit(Events.ScreenShareStarted);
    });

    actionEmitter.on(Actions.StopScreenShare, () => {
        if (!share.value) {
            return;
        }

        if (media.value) {
            media.value.getTracks().forEach(track => track.stop());
        }
        actionEmitter.emit(Actions.ResetMediaStream);
        share.value = false;
        eventEmitter.emit(Events.ScreenShareFinished);

    });

    eventEmitter.on(Events.ScreenShareStarted, () => {
        console.log("Screen share started");
    });
    eventEmitter.on(Events.ScreenShareFinished, () => {
        console.log("Screen share stopped");
    });
});

async function getDisplayMedia() {
    try {
        return await navigator.mediaDevices.getDisplayMedia(displayMediaOptions);
    }
    catch (error) {
        console.error(error);
        return undefined;
    }
}

function toggleShare() {
    if (share.value) {
        actionEmitter.emit(Actions.StopScreenShare, props.rtcId);
    } else {
        actionEmitter.emit(Actions.StartScreenShare, props.rtcId);
    }
}
</script>